/**
 * This helps preserve navigation stacker.
 * Sets index parameter in current window history (location)
 * @param index of current page in the stacker
 * @param rewriteLocation if provided, the location will be rewritten
 */
export function setStackerIndex(index: number, rewriteLocation?: string): void {
    if (index < 0) return;
    if (window.history) {
        const url = addParamToUrl(rewriteLocation || window.location.href, "_sidx_", "" + index);
		// Note: this call WILL NOT change route obtained from Vue Router !!!
		// Value of window.location.href WILL reflect the change
        window.history.replaceState(null, null, url);
    }
}

function addParamToUrl(url: string, name: string, value: string): string {
    let action, query, hash;
    let u = url;
    const qidx = u.indexOf("?");
    if (qidx >= 0) {
        action = u.substring(0, qidx);
        u = u.substring(qidx);
        const hidx = u.lastIndexOf("#");
        if (hidx >= 0) {
            query = u.substring(0, hidx);
            hash = u.substring(hidx);
        } else {
            query = u;
            hash = "";
        }
    } else {
        const hidx = u.lastIndexOf("#");
        query = "";
        if (hidx >= 0) {
            action = u.substring(0, hidx);
            hash = u.substring(hidx);
        } else {
            action = u;
            hash = "";
        }
    }
    if (query.indexOf(name + "=") > 0) return url;
    else {
        // param not there
        if (query === "") query = "?";
        else query = query + "&";
        query = query + name + "=" + encodeURIComponent(value);
        return action + query + hash;
    }
}